import React from 'react';
import styled from 'styled-components';
import castArray from 'lodash/castArray';
import uniq from 'lodash/uniq';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import get from 'lodash/get';
export const numberFormat = Intl.NumberFormat();

const Title = styled(Typography).attrs({
  variant: 'subtitle2',
})``;


const Table = styled.table`
  border-spacing: 10px 0;
`;

export const Allocations = ({ data, title, onClose }) => data
  ? (<Box p={{ xs: 1, sm: 2 }}>
      <Title>{title}</Title>
      <Table>
        <tobdy>
          {data.allocations && data.allocations
          .map(({ amount, donor, investmentId }) => (
            <tr key={amount}>
              <td>{donor}</td>
              <td align="right"><a
                onClick={onClose}
                href={`#/investment/${investmentId}`}
              >${numberFormat.format(Math.round(amount))}</a></td>
            </tr>
          ))}
        </tobdy>
      </Table>
    </Box>)
  : null;

export const currency = ['numericColumn', 'currencyColumn', 'number'];
export const numeric = ['numericColumn', 'number'];
export const number = ['numericColumn', 'numberColumn'];

export const columnTypes = {
  currencyColumn: {
    valueFormatter: ({ value }) => value && !isNaN(value) && `$${numberFormat.format(Math.round(value))}`,
    width: 125,
  },
  numberColumn: {
    valueFormatter: ({ value }) => value && !isNaN(value) && `${numberFormat.format(Math.round(value))}`,
    width: 125,
  },
  number: {
    filter: false,
  }
};

export const headerStyle = {
  backgroundColor: 'rgba(0,0,0,.1)',
  fontWeight: 'bold',
  lineHeight: '32px',
};

export const rowStyle = {
  lineHeight: '24px',
};

const currencyCellStyle = {
  color: 'rgb(0,64,0)',
};

const donationsCellStyle = {
  color: 'blue',
  textDecoration: 'underline',
  cursor: 'pointer',
};

export function comparator(a, b, { data: dataA }, { data: dataB }, isInverted) {
  const direction = isInverted ? -1 : 1;

  if (dataA.__groupIndex === dataB.__groupIndex) {
    if (dataA.__totals) {
      return -1 * direction;
    }
    if (dataB.__totals) {
      return 1 * direction;
    }
    return a > b ? 1 : (a < b ? -1 : 0);
  }
  return (dataA.__index - dataB.__index) * direction;
}

export function comparator2(a, b, { data: dataA }, { data: dataB }, isInverted) {
  const direction = isInverted ? -1 : 1;

  if (dataA.__groupIndex === dataB.__groupIndex) {
    if (dataA.__totals) {
      return -1 * direction;
    }
    if (dataB.__totals) {
      return 1 * direction;
    }
    return a > b ? 1 : (a < b ? -1 : 0);
  }
  return (dataB.__index - dataA.__index) * direction;
}

export const defaultColDef = {
  filter: true, // 'agTextColumnFilter',
  sortable: true,
  flex: 0,
/*  cellStyle: ({ colDef: { type, field }, data: { __totals } }) => ({
    ...(__totals ? headerStyle : rowStyle),
    ...(type === currency ? currencyCellStyle : undefined),
    ...(field === 'numAllocations' ? donationsCellStyle : undefined)
  }),*/
  filterValueGetter: ({ data, colDef: { field } }) => JSON.stringify(data.__totals
    ? uniq(data.reports.map(({ [field]: value }) => value))
    : data[field] || ''
  ),
  comparator,
  filterParams: {
    defaultOption: 'startsWith',
    textCustomComparator(filter, json, filterText) {

      const values = castArray(JSON.parse(json));
      const filterTextLowerCase = filterText.toLowerCase();

      return values.some(value => {
        const valueLowerCase = value.toString().toLowerCase();
  
        switch (filter) {
            case 'contains':
                return valueLowerCase.indexOf(filterTextLowerCase) >= 0;
            case 'notContains':
                return valueLowerCase.indexOf(filterTextLowerCase) === -1;
            case 'equals':
                return valueLowerCase === filterTextLowerCase;
            case 'notEqual':
                return valueLowerCase != filterTextLowerCase;
            case 'startsWith':
                return valueLowerCase.indexOf(filterTextLowerCase) === 0;
            case 'endsWith':
                var index = valueLowerCase.lastIndexOf(filterTextLowerCase);
                return index >= 0 && index === (valueLowerCase.length - filterTextLowerCase.length);
            default:
                // should never happen
                console.warn('invalid filter type ' + filter);
                return false;
            }
        });
      }
  },
};

export const getRowHeight = ({ data }) => data?.groupHeader === undefined ? 64 : 64 + 5;

export const popupParent = document.body;

export const GridContainer = styled.div.attrs({
  className: 'ag-theme-material',
})`
  width: 100%;
`;

export function groupBy(array, field, keyId) {
  if (!array) {
    return array;
  }

  const result = [];
  const cache = {};

  for (const item of array) {
    const key = removeExtraSpaces(get(item, field) || null); // should include empty string too that why not using ??
    let value = cache[key];
    if (!(key in cache)) {
      value = cache[key] = { key, values: [] };
      result.push(value);
    }

    value.values.push(item);
  }

  return keyId
    ? result
        .sort((a, b) => !a.key ? 1 : (!b.key ? -1 : keyId(a.key) - keyId(b.key)))
    : result
        .sort((a, b) => !a.key ? 1 : (!b.key ? -1 : String(a.key).localeCompare(b.key)));
}

export const removeExtraSpaces = s => (typeof s === 'string') ? s.replace(/\s+/g, ' ') : s;

export const escapeQuotes = s => s.replace(/\"/g, '\'');
